import React from "react";
import { observer } from "mobx-react-lite";
import {
  Button,
  Dialog,
  Classes,
  Position,
  Menu,
  MenuItem,
  MenuDivider,
  Popover,
} from "@blueprintjs/core";
import { downloadFile } from "polotno/utils/download";
import { NavLink } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import { useNavigate } from "react-router-dom";
import api from '../config/api';

export const FileMenu = observer(({ store, project }) => {
  const inputRef = React.useRef();
  const navigate = useNavigate();

  const handleSave = async () => {
    try {
      const finalFileName =
        fileName.trim() !== "" ? fileName.trim() : getName();
      if (fileName.trim() === "") {
        setShowPopup(true);
        return;
      }

      const canvasDataURL = await store.toDataURL({
        pixelRatio: quality,
        mimeType: "image/png", // Ensure the mimeType is set to PNG
      });

      setImagePaths((prevPaths) => [...prevPaths, canvasDataURL]);
      console.log("paths", imagePaths);
      alert("Image saved successfully!");

      // Construct your JSON data object
      const jsonData = store.toJSON();
      console.log("JSON Data:", jsonData);

      // Convert JSON data to Blob
      const jsonBlob = new Blob([JSON.stringify(jsonData)], {
        type: "application/json",
      });

      // Convert canvas data URL to Blob
      const imageDataBlob = await fetch(canvasDataURL).then((res) =>
        res.blob()
      );

      // Construct a FormData object
      const formData = new FormData();
      formData.append("title", finalFileName);
      formData.append("edited_by", userID);
      formData.append("templetepath", jsonBlob, finalFileName + ".json");
      formData.append("imagepath", imageDataBlob, finalFileName + ".png");

      // Make the API call to save the user template
      const response = await fetch(api.getUrl(api.ENDPOINTS.SAVE_USER_TEMPLATE), {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Template saved successfully:", result);
        // Handle success
      } else {
        const result = await response.json();
        console.error("Failed to save the template:", result);
        // Handle error
        alert("Failed to save the template. Please try again.");
      }
    } catch (error) {
      console.error("Error saving image:", error);
      alert("Failed to save the image. Please try again.");
    }
  };

  const submit = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            className="custom-ui"
            style={{
              display: "block",
              border: "1px",
              width: "500px",
              borderRadius: "15px",
              borderColor: "#808080",
              backgroundColor: "#F5f5f5",
              padding: "20px",
              maxWidth: "400px",
              
            }}
          >
            <h1 className=" text-xl p-1  font-semibold " style={{fontStyle:"poppins"}}>Are you sure to leave ?</h1>
            <p className=" text-sm p-1  font-normal " style={{fontFamily:"poppins"}}>
              In case of YES you might loss your work.
            </p>
           

           <div className="flex items-center justify-center">
           <button
              className=" m-5  block px-8 py-2 text-white rounded-md" style={{backgroundColor:"#882ED8"}}
              onClick={() => {
                navigate("/");
                onClose();
              }}>

              Yes
            </button>
            <button 
             className=" m-5  block px-8 py-2 text-white rounded-md" style={{backgroundColor:"#882ED8"}}
            onClick={onClose}>No</button>
           </div>
            
          </div>
        );
      },
    });
  };

  const [faqOpened, toggleFaq] = React.useState(false);
  return (
    <>
      {/* <NavLink
        to="/"
        className={`hover:no-underline hover:bg-[#ffffff0f]  px-1 py-[5px] rounded-sm  focus:outline-none active:outline-none ml-4 text-white font-[500] hover:text-white flex items-center gap-2  `}
      >
        {" "}
        <FaChevronLeft /> <span style={{fontFamily:"poppins", fontSize:"14px" , fontWeight:"400"}}>Home</span> 
        </NavLink> */}

      <p
        onClick={submit}
        className={`hover:no-underline hover:bg-[#ffffff0f] text-[18px] px-1 py-[5px] rounded-sm  focus:outline-none active:outline-none ml-4 text-white font-[500] hover:text-white flex items-center gap-2  `}
      >
        {" "}
        <FaChevronLeft />{" "}
        <span
          style={{ fontFamily: "poppins", fontSize: "14px", fontWeight: "400" }}
        >
          Home
        </span>
      </p>

      {/* <Popover
        content={
          <Menu>
           <MenuDivider title={t('toolbar.layering')} /> 
            <MenuItem
              icon="plus"
              text="Create new design"
              onClick={() => {
                project.createNewDesign();
              }}
            />
            <MenuDivider />





            <MenuItem
              icon="folder-open"
              text="Open"
              onClick={() => {
                document.querySelector('#load-project').click();
              }}
            />






            <MenuItem
              // icon={<FaFileExport />}
              icon="floppy-disk"
              text="Save as"
              onClick={() => {
                const json = store.toJSON();

                const url =
                  'data:text/json;base64,' +
                  window.btoa(
                    unescape(encodeURIComponent(JSON.stringify(json)))
                  );

                downloadFile(url, 'polotno.json');
              }}
            />

            <MenuDivider />
            <MenuItem text="Language" icon="translate">
              <MenuItem
                text="English"
                active={project.language.startsWith('en')}
                onClick={() => {
                  project.setLanguage('en');
                }}
              />
              <MenuItem
                text="Portuguese"
                active={project.language.startsWith('pt')}
                onClick={() => {
                  project.setLanguage('pt');
                }}
              />
              <MenuItem
                text="French"
                active={project.language.startsWith('fr')}
                onClick={() => {
                  project.setLanguage('fr');
                }}
              />
              <MenuItem
                text="Russian"
                active={project.language.startsWith('ru')}
                onClick={() => {
                  project.setLanguage('ru');
                }}
              />
              <MenuItem
                text="Indonesian"
                active={project.language.startsWith('id')}
                onClick={() => {
                  project.setLanguage('id');
                }}
              />
            </MenuItem>
            <MenuItem
              text="About"
              icon="info-sign"
              onClick={() => {
                toggleFaq(true);
              }}
            />
          </Menu>
        }
        position={Position.BOTTOM_RIGHT}
      > */}
      {/* <Button minimal text="Create new design"  onClick={() => {
                project.createNewDesign();
              }} style={{color:"white"}} className={`hover:no-underline focus:outline-none active:outline-none mx-3 text-white font-[500]`} 
              
              /> */}
      <button
  minimal
  onClick={() => {
    project.createNewDesign();
  }}
  style={{
    fontSize: "14px",
    fontWeight:"400",
    borderRadius: "10px",
    color: "white",
  }}
  className=" ml-4 hover:bg-gradient-to-r p-2 text-white  text-md mr-3 hover:from-purple-900 hover:via-purple-900 hover:to-purple-900 flex items-center"
>
  <FaPlus
    style={{
      display: "inline-block",
      marginRight: "6px",
      fontFamily: "Poppins",
    }}
  />{" "}
  Create New
</button>



      {/* </Popover> */}

      <input
        type="file"
        id="load-project"
        accept=".json,.polotno"
        ref={inputRef}
        style={{ width: "180px", display: "none" }}
        onChange={(e) => {
          var input = e.target;

          if (!input.files.length) {
            return;
          }

          var reader = new FileReader();
          reader.onloadend = async function () {
            var text = reader.result;
            let json;
            try {
              json = JSON.parse(text);
            } catch (e) {
              alert("Can not load the project.");
            }

            if (json) {
              await project.createNewDesign();
              store.loadJSON(json);
              project.save();
              input.value = "";
            }
          };
          reader.onerror = function () {
            alert("Can not load the project.");
          };
          reader.readAsText(input.files[0]);
        }}
      />
    </>
  );
});
